import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { DayPicker } from 'react-day-picker';
import moment from 'moment';
import { convertDateToMoment, convertMomentToDate } from 'helpers/datetime';
import Chevron from 'svg/chevron-right.svg';
import App from 'modules/App';
import { useLocale } from './hooks';
export const SingleDayPicker = ({ day, disabled = {}, onChange })=>{
    if (!process.env.BROWSER) {
        return null;
    }
    const appLocale = useSelector(App.selectors.locale);
    const appDirection = useSelector(App.selectors.direction);
    const locale = useLocale(appLocale);
    const onSelect = (newDate)=>{
        onChange(convertDateToMoment(newDate).startOf('day'));
    };
    const before = convertMomentToDate(disabled.before);
    const after = convertMomentToDate(disabled.after);
    const weekStartsOn = moment.localeData().firstDayOfWeek();
    return /*#__PURE__*/ _jsx(DayPicker, {
        mode: "single",
        timeZone: "UTC",
        locale: locale,
        dir: appDirection,
        numerals: appLocale === 'ar' ? 'arab' : 'latn',
        weekStartsOn: weekStartsOn,
        disabled: {
            before,
            after
        },
        selected: day && day.toDate(),
        components: {
            Chevron
        },
        animate: true,
        onSelect: onSelect
    });
};
